module.exports = __webpack_public_path__ + "img/cat-with-laptop.94e5e1b5.png";